export const PRODUCTS = [
    { name: "Home", link: "#" },
    { name: "About", link: "#" },
    { name: "Service", link: "#" },
    { name: "Faq", link: "#" },
    { name: "gallery", link: "#" },
  ];
  export const RESOURCES = [
    { name: "Testimonals", link: "#" },
    { name: "News", link: "#" },
    { name: "Team", link: "#" },
    { name: "Faq", link: "#" },
    { name: "gallery", link: "#" },
  ];
  export const COMPANY = [
    { name: "Contact", link: "#" },
    { name: "Portfolio", link: "#" },
    { name: "Press", link: "#" },
    { name: "Customer Stories", link: "#" },
    { name: "communities", link: "#" },
  ];
  export const SUPPORT = [
    { name: "Documentation", link: "#" },
    { name: "Tutorials ", link: "#" },
    { name: "Webinars", link: "#" },
    { name: "Open-source", link: "#" },
  ];
  
  export const Icons = [
    { name: "logo-facebook", link: "#" },
    { name: "logo-twitter", link: "#" },
    { name: "logo-github", link: "#" },
    { name: "logo-linkedin", link: "#" },
    { name: "logo-instagram", link: "#" },
  ];
  